import { Z_STACK } from '../config/layout'
import { useExperienceStore } from '../store/experienceStore'

export function LoadingScreen() {
  const isReady = useExperienceStore((s) => s.isReady)
  const loadProgress = useExperienceStore((s) => s.loadProgress)

  if (isReady && loadProgress >= 0.35) return null

  return (
    <div className="loading-screen" style={{ zIndex: Z_STACK.modal + 5 }}>
      <div className="loading-inner">
        <div className="loading-ring" />
        <h1>Lucy</h1>
        <p>正在编织时空…</p>
        <div className="loading-bar">
          <div style={{ width: `${Math.max(12, loadProgress * 100)}%` }} />
        </div>
      </div>
    </div>
  )
}
